import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientVisitEntity } from './client-visit.entity';

/** PD-17105 — what a visit can be linked to (V7). */
export const VISIT_LINK_ENTITY_TYPES = ['contact', 'opportunity', 'order', 'job', 'competitor'] as const;

export type VisitLinkEntityType = (typeof VISIT_LINK_ENTITY_TYPES)[number];

/**
 * PD-17105 — a visit linked to a record it covered: a person (contact), an
 * opportunity, a quote or order, a job or a competitor (wholesaler).
 * Many-to-many: a job can collect visits over months, and a visit can cover
 * several records. The same shape as event_link and issue_link. Tasks, issues
 * and notes keep their own links (event_link, issue_link, client_note's visit
 * column).
 *
 * SM1 exposure: none (a new table). It holds no client id, so a customer merge
 * moves the visit and its links stay intact.
 */
@Index('visit_link__visit_entity', ['fkVisitId', 'entityType', 'entityId'], { unique: true })
@Index('visit_link__entity', ['entityType', 'entityId'], {})
@Entity('visit_link')
export class VisitLinkEntity extends BaseEntity {
	@Column('int', { name: 'fk_m_sm_client_visit__id', unsigned: true })
	public fkVisitId!: number;

	@Column('varchar', { name: 'entityType', length: 32 })
	public entityType!: VisitLinkEntityType;

	@Column('int', { name: 'entityId', unsigned: true })
	public entityId!: number;

	@ManyToOne(() => ClientVisitEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_m_sm_client_visit__id', referencedColumnName: 'id' }])
	public visit!: ClientVisitEntity;
}
